﻿import {Core} from "../Base/Core";
import {GameManager} from "./GameManager";
import EventEmitter from "eventemitter3";
import {EpochController} from "./EpochController";
import {MoneyType, UpgradeType} from "../enums";

export class EpochsController extends EventEmitter {

    epochById = new Map(); // Dictionary<int, EpochController>
    epochsList = []; // List<EpochController>

    MoneySoftSpeed = 0n;
    MoneySoftSpeedStr = "0";

    Init() {
        this.onPlayerChanged = this.onPlayerChanged.bind(this);

        let worldsNumber = Core.GameData.Epochs.epochs.length;
        this.epochById = new Map(); // Dictionary<int, EpochController>();
        this.epochsList = []; // List<EpochController>();

        for (let i = 0; i < worldsNumber; i++) {
            let w = new EpochController();
            w.Init(Core.GameData.Epochs.epochs[i].id, this);
            this.epochById.set(w.epochId, w);
            this.epochsList.push(w);
        }
        Core.Player.on("Changed", this.onPlayerChanged);
    }

    ClearAll() {
        for (let ep of this.epochsList) {
            ep.ClearAll();
        }
    }

    onPlayerChanged() {
        if (!Core.Player.Initialized) return;
        this.updateMoneySoftSpeed();
    }

    updateMoneySoftSpeed() {
        this.MoneySoftSpeed = 0n;
        for (let e of this.epochsList) {
            this.MoneySoftSpeed += e.GetMoneySoftSpeed();
        }
        if (Core.Boosters.IsIncome2Active) {
            this.MoneySoftSpeed *= 4n;
        } else if (Core.Boosters.IsIncomeActive) {
            this.MoneySoftSpeed *= 2n;
        }
        this.MoneySoftSpeedStr = this.MoneySoftSpeed.toString();
        this.emit("MoneySoftSpeedUpdated");
    }

    EnoughSpaceForCreature(creatureId, mergeFromCreatureId) {
        let epochDataOfMergeCreature = Core.GameData.Epochs.GetByCreatureId(mergeFromCreatureId);
        let epochData = Core.GameData.Epochs.GetByCreatureId(creatureId);
        let epochController = this.epochById.get(epochData.id);

        if (epochData.id != epochDataOfMergeCreature.id) {
            return epochController.EnoughSpaceForSpawn;
        } else {
            return true;
        }
    }

    addCreature(creatureId, checkForEnoughSpace) {
        let epochData = Core.GameData.Epochs.GetByCreatureId(creatureId);
        let epochController = this.epochById.get(epochData.id);
        let creature = epochController.AddCreature(creatureId, checkForEnoughSpace);
        if (creature) {
            this.updateMoneySoftSpeed();
        }
        return creature;
    }

    AddCreatureFromBubble(position) {
        let epochId = 1;
        this.epochById.get(epochId).DespawnBubble();
        let bubbleCreatureUpgradeProgress = Core.Player.PlanetsSave.GetUpgradeProgress(UpgradeType.BubbleCreature);
        let bubbleCreatureIndex = Core.GameData.Upgrades.UpgradeByType(UpgradeType.BubbleCreature).TotalValue(bubbleCreatureUpgradeProgress.upgradeIndex);
        let bubbleCreatureId = Core.GameData.Epochs.GetById(epochId).creatures[bubbleCreatureIndex];
        let controller = this.addCreature(bubbleCreatureId, false);
        if (controller) {
            GameManager.gameView.SpawnCreature(controller, position, false);
        }
    }

    AddCreature(creatureId, position, inBox, fromMerge, checkForEnoughSpace) {
        let controller = this.addCreature(creatureId, checkForEnoughSpace);
        if (controller) {
            let creatureView = GameManager.gameView.SpawnCreature(controller, position, inBox);
            if (fromMerge) {
                Core.UI.adsEvolve.Show(creatureId, creatureView);
            }
            return true;
        }
        return false;
    }

    AddCreatureRandomPosition(creatureId, checkForEnoughSpace = true, inBox = true) {
        return this.AddCreature(creatureId, GameManager.GetRandomPointInCameraView(), inBox, false, checkForEnoughSpace);
    }

    OnCreatureRemoved() {
        this.updateMoneySoftSpeed();
    }

    Step(seconds) {
        let moneyToAdd = this.MoneySoftSpeed * BigInt(~~seconds);
        Core.Player.AddMoney(MoneyType.Soft, moneyToAdd);
    }
}
